import React, { Component } from "react";
import ViewModel from "./controllers/ViewModel";
import MinhaContaView from "./views/MinhaConta";

export default class MinhaConta extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.viewModel = new ViewModel();
    this.viewModel.mirrorState = (s) => this.setState(s);
    this.viewModel.props = props;
  }

  componentDidMount() {
    this.viewModel.init();
  }

  componentWillUnmount() {
    this.viewModel.cleanup();
  }


  render() {
    return (
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="container">
            <MinhaContaView {...this.props} viewModel={this.viewModel} />
          </div>
        </div>
      </div>
    );
  }
}
